import { EgretLoadable } from "egret";
import ConstantList from "app/appConfig";

const PatientFromOther = EgretLoadable({
  loader: () => import("./PatientFromOtherIndex"),
});
// const NewPatientFromOther = EgretLoadable({
//   loader: () => import("./PatientBlankIndex"),
// });

// const FakeRoutes = [...Array(99)].map((_, index) => {
//   return {
//     path: ConstantList.ROOT_PATH + "page" + (index + 1),
//     exact: true,
//     component: NewPatientFromOther,
//   };
// });

const Routes = [
  {
    path: ConstantList.ROOT_PATH + "patient/patient-from-other",
    exact: true,
    component: PatientFromOther,
    detailRole: [
      "viewTransferSystemOther",
    ],
    settings: { layout1Settings: { leftSidebar: { mode: "close" } } }
  },
];

export default Routes;
